// Caricamento di Google Analytics 4 (gtag.js) SOLO dopo il consenso dell'utente.
// L'ID di misurazione predefinito può essere sovrascritto con la variabile
// d'ambiente VITE_GA4_ID nelle impostazioni del progetto Vercel.

export const GA4_ID =
  (import.meta.env.VITE_GA4_ID as string | undefined) || "G-V6N7R8V3HG";

let loaded = false;

export function loadAnalytics(): void {
  if (loaded || !GA4_ID) return;
  loaded = true;

  const w = window as unknown as {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
  };
  w.dataLayer = w.dataLayer || [];
  // Stub gtag IDENTICO a quello ufficiale di Google: accoda l'oggetto
  // `arguments` (non un array), altrimenti gtag.js ignora i comandi.
  function gtag() {
    // eslint-disable-next-line prefer-rest-params
    w.dataLayer!.push(arguments);
  }
  w.gtag = gtag as unknown as (...args: unknown[]) => void;

  // Carica lo script gtag PRIMA di inviare i comandi (come nello snippet ufficiale).
  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA4_ID}`;
  document.head.appendChild(script);

  gtag("js", new Date());
  gtag("config", GA4_ID);
}
